import { useCallback, useState, useRef } from 'react';
import { GetToken } from '@utils/storage';
import * as config from '@config';

function useFeedback() {
    const [submitting, setSubmitting] = useState(false);
    const abortRef = useRef(null);

    const postFeedback = useCallback(async (feedback) => {
        abort();
        setSubmitting(true);
        abortRef.current = new AbortController();
        try {
            const response = await fetch(`${config.apiURL2}/feedback`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${GetToken()}`,
                },
                body: JSON.stringify({ feedback }),
                signal: abortRef.current.signal,
            });
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || 'An error occurred while submitting feedback');
            }
            return await response.json();
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('Request was aborted');
                throw new Error('Request was aborted');
            } else {
                console.error('Error submitting feedback:', error);
            }
            throw error;
        } finally {
            setSubmitting(false);
        }
    }, []);

    const abort = useCallback(() => {
        if (abortRef.current) {
            abortRef.current.abort();
        }
    }, []);

    return { submitting, postFeedback, abort };
}

export default useFeedback;
